import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectSubtractIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 7.25H17.75V2C17.75 1.5858 17.4142 1.25 17 1.25H2C1.5858 1.25 1.25 1.5858 1.25 2V17C1.25 17.4142 1.5858 17.75 2 17.75H7.25V22C7.25 22.4141 7.5859 22.75 8 22.75H22C22.4141 22.75 22.75 22.4141 22.75 22V8C22.75 7.5859 22.4141 7.25 22 7.25ZM21.25 21.25H8.75V8.75H21.25V21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectSubtractIcon.displayName = 'SelectSubtractIcon';
